import axios from "axios";

const API_URL =
  process.env.NODE_ENV === "development"
    ? "http://localhost:5000"
    : "https://api.yearbookhub.online";

const api = axios.create({
  baseURL: API_URL,
  withCredentials: true,
});

export default api;